module.exports = __webpack_public_path__ + "img/victory-background.e11cf5a2.png";